import {Component, Input} from "@angular/core";
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {PromocionInfo} from "../../core/promociones/promocion-info";
import {PromocionesService} from "../../core/promociones/promociones.service";
import {MessageService} from "primeng/components/common/messageservice";

@Component(
    {
        selector: 'set-principal-modal-promotion',
        template: `
            <div class="modal-header">
                <h4 class="modal-title">Promociones</h4>
                <button type="button" class="close" aria-label="Close" [disabled]="loading" (click)="activeModal.dismiss('Cross click')">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                ¿ Está seguro que quiere
                <span class="font-weight-bold">{{promocion.principal ? 'DESMARCAR COMO PRINCIPAL' : 'MARCAR COMO PRINCIPAL'}}</span>?
                <div class="alert alert-warning" *ngIf="detailError">
                    {{detailError}}
                </div>
            </div>
            <div class="modal-footer">
                <div>
                    <button type="button" class="btn btn-danger" [disabled]="loading" (click)="activeModal.close('close')">Cancelar</button>
                    <button type="button" class="btn btn-primary ml-2" [ladda]="loading" (click)="activeModal.close(!promocion.principal)">
                        Aceptar
                    </button>
                </div>
            </div>
        `
    }
)
export class SetPrincipalModalComponent {
    @Input() promocion: any;
    //promociones: PromocionInfo[] = [];
    loading = false;
    private detailError: string;

    constructor(public activeModal: NgbActiveModal, private promocionesService: PromocionesService, private messageService: MessageService) {
    }

    setPrincipal() {

    }

    /*
      disablePromotion() {
        this.loading = true;
        this.promocionesService.changePrincipal(this.promocion).subscribe(() => {
          this.promocion.defaultPromotion = !this.promocion.defaultPromotion;
          if (this.promocion.defaultPromotion) {
            this.promociones.forEach((promo) => {
              if (promo !== this.promocion) {
                promo.defaultPromotion = false;
              }
            });
          }
          this.activeModal.close();
        }, (error) => {
          console.log("PrincipalModalComponent:error");
          console.log(error);
          console.log(error.detail);
          if (error.error.detail === "Incomplete resources") {
            this.detailError = 'La promocion no puede marcarse como PRINCIPAL debido a que no tiene configuradas todas las imagenes'
          }
          this.loading = false;
        });
      } */
}



// WEBPACK FOOTER //
// /codebuild/output/src14910448/src/src/app/components/promociones/set-principal-modal-component.ts